module.exports = __webpack_public_path__ + "d28c96b7fcb5636a64f232ff555ace44.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/boy.png
// module id = 1373
// module chunks = 0